import React from 'react'

function isElementInView(
  ref: React.MutableRefObject<any>,
  threshold = { top: 0, left: 0, right: 0, bottom: 0 }
) {
  if (!ref || !ref.current) {
    return false
  }

  const rect = ref.current.getBoundingClientRect()

  return (
    rect.top >= threshold.top &&
    rect.left >= threshold.left &&
    rect.bottom <=
      (window.innerHeight - threshold.bottom ||
        document.documentElement.clientHeight - threshold.bottom) &&
    rect.right <=
      (window.innerWidth - threshold.right ||
        document.documentElement.clientWidth - threshold.right)
  )
}

export default isElementInView
